"use client";

import { PlusIcon } from "@/assets/icons";
import { useState } from "react";

interface FAQItemProps {
  question: string;
  answer: string | React.ReactNode;
  defaultOpen?: boolean;
}

export function FAQItem({
  question,
  answer,
  defaultOpen = false,
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div
      className="border-b-[0.5px] border-text-primary/20 py-10 first:pt-0 cursor-pointer"
      onClick={() => setIsOpen(!isOpen)}
    >
      <button
        type="button"
        className="w-full flex items-center justify-between gap-3 text-left hover:opacity-80 transition-opacity"
        aria-expanded={isOpen}
      >
        <p className="flex-1 text-xl font-bold text-text-primary leading-normal">
          {question}
        </p>
        <PlusIcon
          className="w-4 h-4 shrink-0 transition-transform duration-300 ease-in-out text-text-primary"
          style={{
            transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
          }}
        />
      </button>
      <div
        className="overflow-hidden transition-all duration-300 ease-in-out"
        style={{
          maxHeight: isOpen ? "1000px" : "0px",
          opacity: isOpen ? 1 : 0,
        }}
      >
        <div
          className="mt-3 text-sm font-normal text-text-secondary leading-normal whitespace-pre-wrap cursor-default"
          onClick={(e) => e.stopPropagation()}
        >
          {answer}
        </div>
      </div>
    </div>
  );
}
